var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Unauthorized Access")]),_c('p',[_vm._v("You do not have the necessary permissions to access this page. If you feel this is in error, please contact:")])])
}]

export { render, staticRenderFns }